import { isMobile } from '../utils/DeviceType';
import { getExploreName } from '../utils/platform';
import { generateVideoToken } from '../utils/util';

export const devConfig = {
  sdkKey: process.env.REACT_APP_ZM_KY || '',
  sdkSecret: process.env.REACT_APP_ZM_SK || '',
  // webEndpoint: 'zoom.us', // zfg use www.zoomgov.com
  topic: 'test',
  name: `${getExploreName()}-${Math.floor(Math.random() * 1000)}`,
  password: '',
  signature: '',
  sessionKey: '',
  userIdentity: '',
  // The user role. 1 to specify host or co-host. 0 to specify participant, Participants can join before the host. The session is started when the first user joins. Be sure to use a number type.
  role: isMobile() ? 0 : 1
};
export const settingForDemo = () => {
  type Args = {
    sdkKey: string;
    topic: string;
    signature: string;
    name: string;
    password?: string;
    webEndpoint?: string;
    enforceGalleryView?: string;
    enforceVB?: string;
    customerJoinId?: string;
    lang?: string;
    useVideoPlayer?: string;
  } & { [key in string]: any };
  let meetingArgs: Args = { ...devConfig };
  // enforce use <video> tag render video, https://marketplacefront.zoom.us/sdk/custom/web/modules/Stream.html#attachVideo
  meetingArgs.useVideoPlayer = '1';
  meetingArgs.telemetry_tracking_id = '';
  if (!meetingArgs.signature && meetingArgs.sdkSecret && meetingArgs.topic) {
    meetingArgs.signature = generateVideoToken(
      meetingArgs.sdkKey,
      meetingArgs.sdkSecret,
      meetingArgs.topic,
      meetingArgs.sessionKey,
      meetingArgs.userIdentity,
      Number(meetingArgs.role ?? 1),
      meetingArgs.cloud_recording_option,
      meetingArgs.cloud_recording_election,
      meetingArgs.telemetry_tracking_id
    );
  }
  const urlArgs: any = {
    topic: meetingArgs.topic,
    name: meetingArgs.name,
    password: meetingArgs.password,
    sessionKey: meetingArgs.sessionKey,
    userIdentity: meetingArgs.userIdentity,
    role: meetingArgs.role || 1,
    cloud_recording_option: meetingArgs.cloud_recording_option || '',
    cloud_recording_election: meetingArgs.cloud_recording_election || '',
    telemetry_tracking_id: meetingArgs.telemetry_tracking_id || '',
    enforceGalleryView: 0,
    enforceVB: 0,
    web: '1'
  };
  console.log('use url args');
  console.log(window.location.origin + '/?' + new URLSearchParams(urlArgs).toString());
  return meetingArgs;
};
